import React, { useState } from 'react';
import PropTypes from 'prop-types';

import useI18n from 'hooks/I18n/useI18n.js';

import Text, { SMALL } from 'src/components/atoms/Text/Text.jsx';
import Title from 'src/components/atoms/Title/Title.jsx';
import LoginForm from 'src/components/organisms/LoginForm/LoginForm.jsx';
import GoogleAuthButton, { SIGNUP_WITH } from 'src/components/atoms/Button/GoogleAuthButton.jsx';
import Snackbar from 'src/components/molecules/Snackbar/Snackbar.jsx';
import { LoadingAnimation } from 'components/ui';

const Login = ({ onSubmit, showSnackbar, googleCallback }) => {
    const { trans } = useI18n();
    const [googleAuthPending, setGoogleAuthPending] = useState(false);
    const handleGoogleCallback = res => {
        const onCallbackFail = () => setGoogleAuthPending(false);
        const onCallbackSucceed = () => setGoogleAuthPending(false);
        setGoogleAuthPending(true);
        googleCallback(res, { onCallbackFail, onCallbackSucceed });
    };

    return (
        <>
            {showSnackbar && (
                <Snackbar
                    delay={4000}
                    message={trans('login.resetPassword.notification.succeed')}
                />
            )}
            <div className="nd-login-container">
                <Title level="3">{trans('login.title')}</Title>
                {googleCallback && process.env.GOOGLE_CLIENT_ID && (
                    <>
                        {googleAuthPending ? (
                            <LoadingAnimation type="pi-spinner" />
                        ) : (
                            <GoogleAuthButton
                                clientId={process.env.GOOGLE_CLIENT_ID}
                                text={SIGNUP_WITH}
                                callback={handleGoogleCallback}
                            />
                        )}
                        <div className="nd-login-separator">
                            <Text size={SMALL}>{trans('global.or')}</Text>
                        </div>
                    </>
                )}
                <LoginForm onSubmit={onSubmit} />
            </div>
        </>
    );
};

Login.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    showSnackbar: PropTypes.bool,
    googleCallback: PropTypes.func,
};

export default Login;
